import { render, staticRenderFns } from "./ExpertStatusOld.vue?vue&type=template&id=80d846aa&scoped=true"
import script from "./ExpertStatusOld.vue?vue&type=script&lang=js"
export * from "./ExpertStatusOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d846aa",
  null
  
)

export default component.exports